(function () {
  document.querySelectorAll('[data-premium-recommendations]').forEach(function (host) {
    if (host.querySelector('.recommended__grid')) return;

    var url = host.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sectionId = host.getAttribute('data-section-id');
        var sectionRoot =
          (sectionId && doc.getElementById('shopify-section-' + sectionId)) ||
          doc.querySelector('.premium-pdp-recommended');

        if (!sectionRoot) return;

        var grid = sectionRoot.querySelector('.recommended__grid');
        if (!grid) return;

        host.innerHTML = '';
        host.appendChild(grid.cloneNode(true));
      })
      .catch(function () {});
  });
})();
